// extracted by mini-css-extract-plugin
export default {"link":"oIRgAP","image":"nZuqoz","root":"AGM571"};